<ul class="side-nav fixed {{menuVisible}}">
    <li class="logo-container">
        <a class="brand-logo">
            <img class="logo" style="height: 35px; width: auto;" src="/api/Application/DealershipLogo/">
        </a>
    </li>
    <li *ngIf="showUndercarriage || showGet">
        <a class="waves-effect waves-red" [href]="undercarriageUrl"><i class="material-icons">arrow_back</i>Return to Home</a>
    </li>
    <!-- TT-4813-->
    <!-- <li *ngIf="showGet">
        <a class="waves-effect waves-red" [href]="undercarriageUrl"><i class="material-icons">arrow_back</i>Return to GET</a>
    </li> -->

    <li *ngIf="showDigitalForm==true">
        <a class="waves-effect waves-red" [href]="formadmin"><i class="material-icons">dynamic_form</i>Form Administration</a>
    </li>
    <li *ngIf="showDigitalForm==true">
        <a class="waves-effect waves-red" [href]="formsearch"><i class="material-icons">find_in_page</i>Search Digital Form</a>
    </li>

    <li>
        <a class="waves-effect waves-red"  [href]="logouturl" ><i style="transform: rotate(180deg);" class="material-icons">exit_to_app</i>Logout</a>
    </li>
</ul>